export const PEDIDO_CONCLUIDO_TITULO = 'Solicitação de cancelamento concluída'

export const MUDOU_IDEIA_TITULO = 'Mudou de ideia?'

export const getFraseModalidade = modalidade => {
  const tituloModalidade = modalidade.charAt( 0 ).toUpperCase() + modalidade.slice( 1 )
  return `Sua solicitação de cancelamento da TAG ${tituloModalidade} foi recebida com sucesso.`
}

export const AVISO_COBRANCA = 'Não serão realizadas novas cobranças e em breve confirmaremos a sua solicitação de cancelamento através do e-mail cadastrado.'

export const AGRADECIMENTO = 'Agradecemos por ter feito parte da nossa história e esperamos que você possa retornar em breve. 📚'

export const DESFAZER_CANCELAMENTO_TEXTO = 'Você pode desfazer a solicitação de cancelamento a qualquer momento. É só acessar a aba "Home" aqui na Área do Associado.'

export const PERMANECER_TEXTO = 'Ficaremos muito felizes caso você decida permanecer no clube!'

